// src/frontend/src/hooks/useDocumentTitle.ts
import { useEffect } from 'react';

const APP_NAME = 'Sortsofort';

/**
 * Set `document.title` for the screen that is currently rendered.
 *
 * `index.html` carries one static title, so before this every route read the
 * same thing in the tab, in browser history and in a shared link (F26).
 *
 * The caller passes an **already translated** string — `t()` lives in the page,
 * which means the title re-renders on a language change like everything else,
 * and a detail page can pass a localised record name instead of a fixed label.
 * Pass nothing (or null, while data is still loading) for the bare app name.
 *
 * `<html lang>` is deliberately not touched here: that belongs to i18n/i18n.js
 * and setting it from two places is how F25 regressed.
 */
export function useDocumentTitle(title?: string | null): void {
    useEffect(() => {
        if (typeof document === 'undefined') return;
        document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
    }, [title]);
}

export default useDocumentTitle;
